import React, { ReactEventHandler } from "react";
import Dialog from "@mui/material/Dialog";
import { useTypedDispatch, useTypedSelector } from "hooks/store";
import { DialogOpenType, openDialog } from "state/slices/DialogSlice";
import "./DialogComponent.scss";
import DialogDefaultContent from "./DialogDefaultContent";
import DialogSaveModelContent from "./DialogSaveModelContent";
import DialogSaveSceneJsonContent from "./DialogSaveSceneJsonContent";
import DialogReportIssue from "./DialogReportIssue";
import DialogChangePatient from "./DialogChangePatient";

const DialogComponent = (): JSX.Element => {
    const dispatch = useTypedDispatch();
    const isOpenDialog = useTypedSelector((store) => store.Dialog.isDialogOpen);
    const type = useTypedSelector((store) => store.Dialog.type);

    const renderDialogContent = () => {
        switch (type) {
            case DialogOpenType.ResetRoom:
                return <DialogDefaultContent title="Are you sure you want to reset the room?" />;
            case DialogOpenType.Logout:
                return <DialogDefaultContent title="Are you sure you want to logout?" />;
            case DialogOpenType.NewSetup:
                return <DialogDefaultContent title="Are you sure you want to do new setup?" />;
            case DialogOpenType.LoadSetup:
                return <DialogDefaultContent title="Are you sure you want to load setup?" />;
            case DialogOpenType.Import:
                return (
                    <DialogDefaultContent title="Are you sure you want to import a new setup?" />
                );
            case DialogOpenType.SaveRoom:
                return <DialogSaveModelContent />;
            case DialogOpenType.SaveSceneJson:
                return <DialogSaveSceneJsonContent />;
            case DialogOpenType.ReportIssue:
                return <DialogReportIssue />;
            case DialogOpenType.ChangePatient:
                return <DialogChangePatient />;
        }
    };

    const handleClose = (event: ReactEventHandler, reason: string) => {
        if (reason !== "backdropClick") {
            dispatch(openDialog({ isDialogOpen: false, type: DialogOpenType.Null }));
        }
    };
    return (
        <div>
            <Dialog
                className={`cmrDialogContainer ${type}`}
                disableEscapeKeyDown={true}
                open={isOpenDialog}
                onClose={handleClose}
                aria-labelledby="cmrDialogTitle"
                aria-describedby="cmrDialogDescription"
            >
                <section className={type} id={type === "saveRoom" ? "saveRoom" : ""}>
                    {renderDialogContent()}
                </section>
            </Dialog>
        </div>
    );
};

export default DialogComponent;
